'use client'
import { Button } from '@components/ui/button'
import { WalletBulkIcon } from '@components/icons/bulk'
import clsx from 'clsx'
import { usePrivyAuth } from '../context/usePrivyAuth.hook'
import { useState, useEffect } from 'react'

export const PrivyAuthButton = ({
  isAuthenticated,
  buttonType = 'default',
  buttonSize = 'md',
  buttonVariant = 'purple',
  buttonClassName,
  buttonText = 'Log in or Sign up',
  onActionClick,
  onAuthSuccess,
  landingPage = false,
  headerOpacity,
}: {
  isAuthenticated: boolean
  buttonType?: 'default' | 'mobile'
  buttonSize?: 'md' | 'lg'
  buttonVariant?: 'purple' | 'secondary' | 'green' | 'primary'
  buttonClassName?: string
  buttonText?: string
  onActionClick?: () => void
  onAuthSuccess?: () => void
  landingPage?: boolean
  headerOpacity?: number
}) => {
  const { triggerLogin } = usePrivyAuth()
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  // During SSR and initial render, always render the button to prevent hydration mismatch
  // After mount, check authentication state
  if (isMounted && isAuthenticated) {
    return null
  }

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    triggerLogin({
      onActionClick,
      onAuthSuccess,
    })
  }

  if (buttonType === 'mobile') {
    // When headerOpacity is 0, white icon is fully visible (opacity 1), purple is hidden (opacity 0)
    // When headerOpacity is 1, white icon is hidden (opacity 0), purple is fully visible (opacity 1)
    const whiteIconOpacity =
      landingPage && headerOpacity !== undefined ? 1 - headerOpacity : 0
    const purpleIconOpacity =
      landingPage && headerOpacity !== undefined ? headerOpacity : 1

    return (
      <div className={clsx('relative inline-block h-11 w-11 top-1', buttonClassName)}>
        <WalletBulkIcon
          className="absolute top-0 left-0 h-11 w-11 cursor-pointer text-white"
          style={{
            opacity: whiteIconOpacity,
            transition: 'opacity 0.3s ease-in-out',
          }}
          onClick={handleClick}
        />
        <WalletBulkIcon
          className="absolute top-0 left-0 h-11 w-11 cursor-pointer text-cw-midnight-purple"
          style={{
            opacity: purpleIconOpacity,
            transition: 'opacity 0.3s ease-in-out',
          }}
          onClick={handleClick}
        />
      </div>
    )
  }

  return (
    <Button
      variant={buttonVariant}
      size={buttonSize}
      className={buttonClassName}
      onClick={handleClick}
    >
      {buttonText}
    </Button>
  )
}
